export const creditType = `
  _id
  balance
  email
  initialValue
  number
  user
`